module.exports = __webpack_public_path__ + "img/traffic.58a908d4.png";